import { Widget as WidgetGen } from '@app/gen/dashboard';

import {
  WidgetIconConfig,
  WidgetSettings,
  SectionKey,
  DashboardGridItem,
} from '../../types';

export const COLUMN_COUNT = 3;
export const MIN_ROWS_COUNT: Record<SectionKey, number> = {
  main: 4,
  top: 1,
  posts: 1,
};
const SIZE_S = 1;
const SIZE_M = 2;

export const DROPPABLE_SECTION_PREFIX = 'dashboard-section-';
export const DASHBOARD_EMPTY_CELL_ID_PREFIX = 'dashboard-empty-cell-';
export const DRAG_ACTIVATION_DISTANCE = 5;

export const DEBOUNCE_TIMEOUT = 100;

export const RADIO_OPTIONS = [
  { label: 'S', value: 1 },
  { label: 'M', value: 2 },
  { label: 'L', value: 3 },
];

export const WIDGET_ICONS_CONFIG: Record<WidgetGen['type'], WidgetIconConfig> =
  {
    calendar: {
      iconName: 'calendar_outline',
      iconColor: 'accent.text.success',
      bgColor: 'accent.bg.success',
    },
    links: {
      iconName: 'services_outline',
      iconColor: 'accent.text.warning',
      bgColor: 'accent.bg.warning',
    },
    quick_actions: {
      iconName: 'arrow_up_right_outline',
      iconColor: 'stroke.tertirary',
      bgColor: 'bg.greyscale.primary',
    },
    personal_links: {
      iconName: 'linked',
      iconColor: 'original.brand.primary',
      bgColor: 'original.brand.secondary',
    },
    partitions_company: {
      iconName: 'user_star_outline',
      iconColor: 'accent.text.blue',
      bgColor: 'accent.bg.blue',
    },
    partitions_employee: {
      iconName: 'computer_smartphone_outline',
      iconColor: 'accent.text.blue',
      bgColor: 'accent.bg.blue',
    },
    tasks: {
      iconName: 'vkhrtek_task_list',
      iconColor: 'accent.text.warning',
      bgColor: 'accent.bg.warning',
    },
    external: {
      iconName: 'external_link_outline',
      iconColor: 'accent.text.blue',
      bgColor: 'accent.bg.blue',
    },
    banner: {
      iconName: 'photos_stack_outline',
      iconColor: 'accent.text.review',
      bgColor: 'accent.bg.review',
    },
    news: {
      iconName: 'advertising_outline',
      iconColor: 'accent.text.warning',
      bgColor: 'accent.bg.warning',
    },
    surveys: {
      iconName: 'vkhrtek_rectangles_2_outline',
      iconColor: 'accent.text.blue',
      bgColor: 'accent.bg.blue',
    },
    absences: {
      iconName: 'vkhrtek_vacations_page',
      iconColor: 'accent.text.success',
      bgColor: 'accent.bg.success',
    },
    top_news: {
      iconName: 'flash_outline',
      iconColor: 'accent.text.warning',
      bgColor: 'accent.bg.warning',
    },
    posts_feed: {
      iconName: 'cards_2_outline',
      iconColor: 'accent.text.violet',
      bgColor: 'accent.bg.review',
    },
    birthdays: {
      iconName: 'flapper_outline',
      iconColor: 'accent.text.error',
      bgColor: 'accent.bg.error',
    },
  };

export const DASHBOARD_ENTITIES = {
  company: {
    name: 'Компания',
  },
  account: {
    name: 'Аккаунт',
  },
};

export const TOOLTIP_LABELS = {
  resetWidget:
    'Сброс настроек главной страницы вернёт расположение и содержание виджетов до настроек по умолчанию, назначенных на аккаунт',
  linkedWidgetTitle: 'Виджет привязан к аккаунту',
  linkedWidgetDescription:
    'Содержание виджета зависит от настроек аккаунта. Чтобы отвязать виджет, отредактируйте его и сохраните изменения',
};

export const NOTIFY_TEXT = {
  addException: 'Компания успешно добавлена в исключения',
  errorAddException: 'Не удалось добавить исключение',
  changeLayout: 'Расположение виджетов на главной странице успешно изменено',
  errorChangeLayout:
    'Не удалось изменить расположение виджетов на главной странице',
};

export const LAYOUT_FIELDS = ['x', 'y', 'size'];
export const OPTION_FIELDS = ['hasSettings', 'switchable', 'hasFilters'];
export const OPTION_ENTITY: Record<keyof WidgetSettings, string> = {
  user_editable: 'hasSettings',
  user_switchable: 'switchable',
  has_filter: 'hasFilters',
};

export const SPECIFIC_FIELDS: Record<string, WidgetGen['type'][]> = {
  hasSettings: ['news', 'quick_actions', 'surveys'],
  hasFilters: ['news'],
};

export const EDITABLE_WIDGETS = [
  'links',
  'banner',
  'partitions_employee',
  'partitions_company',
  'quick_actions',
  'absences',
  'top_news',
  'posts_feed',
  'tasks',
  'birthdays',
];

export const FIXED_WIDGET_SIZE: Partial<Record<WidgetGen['type'], number>> = {
  quick_actions: 3,
  posts_feed: 2,
  calendar: 1,
  partitions_company: 2,
  partitions_employee: 2,
};

export const WIDGET_AVAILABLE_SIZES: Partial<
  Record<WidgetGen['type'], number[]>
> = {
  birthdays: [SIZE_S, SIZE_M],
};

export const EMPTY_CELL: DashboardGridItem = { type: 'empty' };
export const OCCUPIED_CELL: DashboardGridItem = { type: 'occupied' };
export const WIDGET_CELL = { type: 'widget' as const };
